export { de } from '@payloadcms/translations/languages/de'
